// Game configuration: constants, characters and procedural level builder.

export const GAME = {
  WIDTH: 960,
  HEIGHT: 540,
  GROUND_Y: 472,
  GRAVITY: 0.72,
  MAX_FALL: 16,
  FRICTION: 0.78,
};

// Three playable characters. Powers for Don Gregorio & Jorge are SWAPPED per request:
//  - Don Gregorio -> VELOCIDAD (speed/double-jump/dash)
//  - Jorge        -> FUERZA (ground-pound)
//  - La Borracha  -> BOTELLAZO (throws bottles)
export const CHARACTERS = [
  {
    id: "jahoskachamorro",
    name: "Jahoska Chamorro",
    tagline: "La Reina del Ring",
    nameColor: "#c2185b",
    link: { url: "https://www.instagram.com/jahoska_/?hl=en", label: "Follow @JahoskaChamorro" },
    ability: "hypno",
    power: "HYPNOTIZE PUNCH",
    powerDesc: "¡Súper rápida y doble salto! Lanza (K) un puñetazo con magia hipnótica que tumba enemigos.",
    speed: 5.2,
    jump: -16.0,
    jumps: 2,
    guest: true,
    isNew: true,
    colors: {
      skin: "#e0b088", skinDark: "#b98a60", hair: "#1a1210", hat: "#c2185b",
      hatBand: "#ffffff", shirt: "#e2295b", shirtDark: "#a3123f", pants: "#0a47d6",
      shoes: "#ffffff", accent: "#c44dff",
    },
  },
  {
    id: "isaacreyes",
    name: "Isaac Reyes",
    tagline: "Actor & Singer",
    nameColor: "#c79a25",
    link: { url: "https://www.instagram.com/isaacreyes.official/?hl=en", label: "Follow @IsaacReyes" },
    ability: "starnote",
    power: "STAR POWER",
    powerDesc: "¡Súper rápido y doble salto! Lanza (K) estrellas y notas musicales doradas desde su micrófono.",
    speed: 5.0,
    jump: -16.0,
    jumps: 2,
    guest: true,
    isNew: true,
    colors: {
      skin: "#d2a173", skinDark: "#a87a4e", hair: "#1c1410", hat: "#1c1410",
      hatBand: "#c79a25", shirt: "#1a1a1a", shirtDark: "#0e0e0e", pants: "#eef0f2",
      shoes: "#15110d", accent: "#e0a82e",
    },
  },
  {
    id: "javydade",
    name: "JavyDade",
    tagline: "New Music Out Now",
    nameColor: "#000000",
    link: { url: "https://open.spotify.com/artist/5x2MghffUs9Ypcb9pOsrWH?si=nz-vB_sESQmmomJ8ogIEVA", label: "Follow @JavyDade" },
    ability: "nacatamal",
    power: "NACATAMALAZO",
    powerDesc: "Lanza nacatamales (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    speed: 4.9,
    jump: -15.5,
    jumps: 2,
    guest: true,
    colors: {
      skin: "#c08a5a", skinDark: "#9c6c40", hair: "#1a1410", hat: "#0a3fa8",
      hatBand: "#ffffff", shirt: "#0a47d6", shirtDark: "#072f8f", pants: "#acc4e6",
      shoes: "#ffffff", accent: "#0a47d6",
    },
  },
  {
    id: "elvin",
    name: "Elvin Espinoza",
    tagline: "The Prodigy",
    nameColor: "#000000",
    link: { url: "https://www.instagram.com/elvinespinoza_/?hl=en", label: "Follow ElvinEspinoza" },
    ability: "electric",
    power: "Right Hook",
    powerDesc: "Lanza rayos eléctricos (K) desde su guante que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    speed: 5.1,
    jump: -15.5,
    jumps: 2,
    guest: true,
    isNew: true,
    colors: {
      skin: "#c08a5a", skinDark: "#9c6c40", hair: "#141414", hat: "#111111",
      hatBand: "#00d8ff", shirt: "#d32f2f", shirtDark: "#8a1f1f", pants: "#1a1a1a",
      shoes: "#1a1a1a", accent: "#00d8ff",
    },
  },
  {
    id: "mercado",
    name: "Daniel Mercado",
    tagline: "El Unico OneTime",
    nameColor: "#16275e",
    link: { url: "https://www.instagram.com/theonlydanielmercado/", label: "Follow @TheOnlyDanielMercado" },
    ability: "tornado",
    power: "Right Hand KO",
    powerDesc: "Lanza tornados (K) desde su guante derecho que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    speed: 5.1,
    jump: -15.5,
    jumps: 2,
    guest: true,
    isNew: true,
    colors: {
      skin: "#c89066", skinDark: "#a06e44", hair: "#141414", hat: "#141414",
      hatBand: "#1b3a8f", shirt: "#c89066", shirtDark: "#a06e44", pants: "#16275e",
      shoes: "#16275e", accent: "#1b3a8f",
    },
  },
  {
    id: "nicaflow",
    name: "NicaFlow",
    tagline: "Follow me on TikTok",
    nameColor: "#000000",
    link: { url: "https://www.tiktok.com/@nicaflow505", label: "Follow @nicaflow505" },
    ability: "coconut",
    power: "Cocazo",
    powerDesc: "Lanza cocos (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    speed: 5.0,
    jump: -15.5,
    jumps: 2,
    guest: true,
    colors: {
      skin: "#c9925f", skinDark: "#a3713f", hair: "#141414", hat: "#111111",
      hatBand: "#00f2ea", shirt: "#00f2ea", shirtDark: "#0bb8b2", pants: "#1a1a1a",
      shoes: "#ffffff", accent: "#ff0050",
    },
  },
  {
    id: "angelmick",
    name: "Angel Mick",
    tagline: "New Music Out Now",
    nameColor: "#000000",
    link: { url: "https://open.spotify.com/artist/6RO5jLYzVIPuQtOLkbAsHY?si=7bmRgvmrRuCSokUCpNl6Eg", label: "Follow @AngelMickMusic" },
    ability: "notes",
    power: "NOTAS MUSICALES",
    powerDesc: "Canta notas musicales (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    speed: 4.8,
    jump: -15.0,
    jumps: 2,
    guest: true,
    colors: {
      skin: "#c89668", skinDark: "#a3754a", hair: "#141414", hat: "#ffffff",
      hatBand: "#5b2a86", shirt: "#1a1a1a", shirtDark: "#000000", pants: "#1a1a1a",
      shoes: "#111111", accent: "#5b2a86",
    },
  },
  {
    id: "influencer",
    name: "El Influencer Nica",
    tagline: "Pancho Rides",
    nameColor: "#000000",
    link: { url: "https://www.tiktok.com/@elinfluencer_nica", label: "Follow @elinfluencer_nica" },
    ability: "ball",
    power: "BALONAZO NICA",
    powerDesc: "Patea balones de fútbol (K) que tumban enemigos. ¡SÚPER RÁPIDO + DOBLE SALTO!",
    speed: 4.8,
    jump: -15.0,
    jumps: 2,
    guest: true,
    colors: {
      skin: "#cf9d6e", skinDark: "#a87a4e", hair: "#171717", hat: "#111111",
      hatBand: "#ffd400", shirt: "#ffd400", shirtDark: "#e0b800", pants: "#a8c4e6",
      shoes: "#ffffff", accent: "#ffd400",
    },
  },
  {
    id: "chasedawson",
    name: "Chase Dawson",
    tagline: "Jugador de Béisbol de Nicaragua",
    link: { url: "https://www.instagram.com/chasedawson24/?hl=en", label: "Follow @ChaseDawson" },
    ability: "homerun",
    power: "HOME RUN",
    powText: "HOME RUN",
    powerDesc: "Batea un jonrón (K) que manda la pelota volando y tumba enemigos. ¡Súper rápido y doble salto!",
    speed: 4.8,
    jump: -15.8,
    jumps: 2,
    spriteScale: 1.95,
    guest: true,
    invited: true,
    isNew: true,
    variants: [
      { key: "nica", label: "Nicaragua", sprite: "chasedawson_nica", ability: "homerun", power: "HOME RUN", powText: "HOME RUN" },
      { key: "leones", label: "Leones", sprite: "chasedawson_leones", ability: "ball", multiShot: 3, ballKind: "baseball", actLabelKey: "actTriplePlay", powerKey: "powerTriplePlay", actLabel: "Triple Play", power: "TRIPLE PLAY", powText: "TRIPLE PLAY" },
    ],
    colors: {
      skin: "#e6b78a", skinDark: "#c99667", hair: "#8a5a2b", hat: "#1e50c8",
      hatBand: "#ffffff", shirt: "#1e50c8", shirtDark: "#173a94", pants: "#f2f2f2",
      shoes: "#1e50c8", accent: "#1e50c8",
    },
  },
  {
    id: "dongregorio",
    name: "Don Gregorio",
    tagline: "Mr Positivity",
    link: { url: "https://www.GregMiceli.com", label: "Visit My Website" },
    ability: "fritanga",
    power: "FRITANGAZO",
    powerDesc: "Corre rapidísimo, triple salto y lanza fritangas (K) que tumban enemigos.",
    speed: 4.9,
    jump: -16.2,
    jumps: 3,
    guest: true,
    invited: true,
    isNew: true,
    colors: {
      skin: "#d9a06b", skinDark: "#b9824f", hair: "#efe7d2", hat: "#e8d090",
      hatBand: "#3aa657", shirt: "#f3ead2", shirtDark: "#d9cfae", pants: "#6b5a3e",
      shoes: "#3a2c18", accent: "#3aa657",
    },
  },
  {
    id: "gordankemash",
    name: "Gordon Kemash",
    tagline: "Doing Nicaraguan Things",
    link: { url: "https://www.instagram.com/gordonkemash?igsh=dGpyMTFwOWRjNGt3", label: "Follow @GordanKemash" },
    ability: "fritanga",
    power: "DOING NICARAGUAN THINGS",
    powText: "DOING NICARAGUAN THINGS",
    powerDesc: "Corre rápido, doble salto y lanza fritangas (K) como Don Gregorio.",
    speed: 4.9,
    jump: -16.2,
    jumps: 2,
    spriteScale: 2.0,
    guest: true,
    invited: true,
    isNew: true,
    colors: {
      skin: "#d9a877", skinDark: "#b98a54", hair: "#c9a15a", hat: "#b9b0a4",
      hatBand: "#ff7a18", shirt: "#b9b0a4", shirtDark: "#8f877c", pants: "#c7c2b6",
      shoes: "#6b4a2c", accent: "#ff7a18",
    },
  },
  {
    id: "nacatamal",
    name: "El Nacatamal",
    tagline: "Nacatambuche",
    nameColor: "#3d6b1f",
    ability: "bread",
    power: "PANAZO",
    powerDesc: "¡Súper rápido y doble salto! Lanza pan (K) que tumba enemigos.",
    speed: 4.9,
    jump: -16.5,
    jumps: 2,
    colors: {
      skin: "#5a8a3a", skinDark: "#3d6b1f", hair: "#2f5217", hat: "#3d6b1f",
      hatBand: "#8a6d3b", shirt: "#4e7d2e", shirtDark: "#36571f", pants: "#5a8a3a",
      shoes: "#e8552d", accent: "#5a8a3a",
    },
    food: true,
    coinCost: 20,
    isNew: true,
  },
  {
    id: "quesillo",
    name: "El Quesillo",
    tagline: "Ese es el mero quesillo de Nagarote.",
    nameColor: "#c08a1e",
    ability: "cream",
    power: "CREMAZO",
    powerDesc: "¡Súper rápido y doble salto! Le exprime crema (K) a los enemigos desde su quesillo.",
    speed: 4.9,
    jump: -16.5,
    jumps: 2,
    food: true,
    coinCost: 20,
    isNew: true,
    colors: {
      skin: "#ead9a0", skinDark: "#cbb877", hair: "#e8d49a", hat: "#f2e6c0",
      hatBand: "#e0c074", shirt: "#ead9a0", shirtDark: "#cbb877", pants: "#ead9a0",
      shoes: "#c98a3a", accent: "#e0a82e",
    },
  },
  {
    id: "ranchero",
    name: "El Ranchero",
    tagline: "El Vaquero Pinolero",
    coinCost: 8,
    ability: "machete",
    power: "MACHETAZO",
    powerDesc: "Da un machetazo (K) de largo alcance que corta a los enemigos.",
    speed: 4.3,
    jump: -16.2,
    jumps: 2,
    colors: {
      skin: "#cf9760", skinDark: "#a9763f", hair: "#3a2a1a", hat: "#6b4423",
      hatBand: "#0067C6", shirt: "#0067C6", shirtDark: "#0b4f97", pants: "#3a2c1a",
      shoes: "#5a3a1e", accent: "#0067C6",
    },
  },
  {
    id: "pandillero",
    name: "El Pandillero",
    tagline: "El Más Vivo Del Barrio",
    coinCost: 8,
    ability: "rock",
    power: "PEDRADA",
    powerDesc: "Lanza piedras (K) para tumbar enemigos a distancia.",
    speed: 4.0,
    jump: -15.0,
    jumps: 2,
    colors: {
      skin: "#b07a4a", skinDark: "#8a5c34", hair: "#1a1a1a", hat: "#c62828",
      hatBand: "#c62828", shirt: "#b07a4a", shirtDark: "#8a5c34", pants: "#3b5b86",
      shoes: "#222222", accent: "#c62828",
    },
  },
  {
    id: "laborracha",
    name: "La Borracha",
    tagline: "La Reina De La Fiesta",
    coinCost: 8,
    ability: "throw",
    power: "BOTELLAZO",
    powerDesc: "Lanza botellas de cerveza (K) para tumbar enemigos a distancia.",
    speed: 3.5,
    jump: -13.8,
    jumps: 2,
    colors: {
      skin: "#e8b894", skinDark: "#cc9a74", hair: "#241a14", hat: "#E91E63",
      hatBand: "#ffd400", shirt: "#E91E63", shirtDark: "#b5174d", pants: "#7a1740",
      shoes: "#ffd400", accent: "#E91E63",
    },
  },
  {
    id: "jorge",
    name: "Jorge Carcamo",
    tagline: "Curious123 Soccer Camps",
    link: { url: "https://www.Curious123.com", label: "Curious123 Soccer Camps" },
    ability: "ball",
    power: "TRIPLE BALONAZO",
    powerDesc: "Patea 3 balones de fútbol (K) a la vez para tumbar enemigos. ¡Súper rápido y doble salto!",
    multiShot: 3,
    speed: 4.8,
    jump: -15.5,
    jumps: 2,
    guest: true,
    isNew: true,
    colors: {
      skin: "#e0b080", skinDark: "#c4945f", hair: "#2a2118", hat: "#0067C6",
      hatBand: "#ffffff", shirt: "#1f8fff", shirtDark: "#1568bf", pants: "#26324d",
      shoes: "#111111", accent: "#0067C6",
    },
  },
  {
    id: "surfista",
    name: "El Surfista",
    tagline: "La Leyenda De San Juan",
    coinCost: 8,
    ability: "chop",
    power: "KARATAZO",
    powerDesc: "Da un karatazo (K) que noquea a los enemigos de enfrente.",
    speed: 4.0,
    jump: -14.8,
    jumps: 2,
    colors: {
      skin: "#c98a55", skinDark: "#a36c3c", hair: "#5a3a1e", hat: "#1fb6a6",
      hatBand: "#ff8a3a", shirt: "#c98a55", shirtDark: "#a36c3c", pants: "#1fb6a6",
      shoes: "#c98a55", accent: "#1fb6a6",
    },
  },
  {
    id: "gueguense",
    name: "El Güegüense",
    tagline: "El Pícaro Enmascarado",
    ability: "maraca",
    actLabelKey: "act_maraca",
    power: "MARACAZO MÁGICO",
    powerDesc: "TRIPLE SALTO + lanza maracas mágicas (K) que tumban enemigos. ¡Ideal para niveles difíciles!",
    speed: 4.2,
    jump: -15.5,
    jumps: 3,
    lockTier: 5,
    coinCost: 7,
    cultural: true,
    colors: {
      skin: "#caa07a", skinDark: "#a87f59", hair: "#3a2a18", hat: "#b8860b",
      hatBand: "#E91E63", shirt: "#1f8fff", shirtDark: "#1568bf", pants: "#7a1fa2",
      shoes: "#3a2c18", accent: "#FFC107",
    },
  },
  {
    id: "gigantona",
    name: "La Gigantona",
    tagline: "La Reina Del Carnaval",
    ability: "spin",
    actLabelKey: "act_spin",
    power: "GIRO GIGANTE",
    powerDesc: "TRIPLE SALTO altísimo + GIRO veloz (K) que noquea a los enemigos alrededor. ¡Domina cualquier nivel!",
    speed: 3.7,
    jump: -17.2,
    jumps: 3,
    lockTier: 25,
    coinCost: 30,
    cultural: true,
    spriteScale: 2.05,
    colors: {
      skin: "#e8c0a0", skinDark: "#caa07a", hair: "#241a14", hat: "#E91E63",
      hatBand: "#FFEB3B", shirt: "#ff3da6", shirtDark: "#c41f7a", pants: "#1f8fff",
      shoes: "#ffffff", accent: "#FFEB3B",
    },
  },
  {
    id: "enanocabezon",
    name: "El Enano Cabezón",
    tagline: "Pareja de La Gigantona",
    ability: "headbutt",
    actLabelKey: "act_headbutt",
    power: "CABEZAZO",
    powerDesc: "Da un cabezazo (K) que noquea a los enemigos de enfrente. ¡Triple salto!",
    speed: 4.2,
    jump: -14.8,
    jumps: 3,
    cultural: true,
    lockTier: 15,
    coinCost: 18,
    colors: {
      skin: "#e0b088", skinDark: "#b98a60", hair: "#1a1210", hat: "#1a1a1a",
      hatBand: "#c62828", shirt: "#f3ead2", shirtDark: "#d9cfae", pants: "#3b4252",
      shoes: "#2a2018", accent: "#1b3a8f",
    },
  },
  {
    id: "elespanol",
    name: "El Español",
    tagline: "Del Toro Huaco",
    ability: "maraca",
    actLabelKey: "act_maraca",
    power: "SONAJA MÁGICA",
    spriteScale: 2.0,
    powerDesc: "Lanza maracas de morro (K) para tumbar enemigos a distancia. ¡Triple salto!",
    speed: 4.2,
    jump: -15.0,
    jumps: 3,
    cultural: true,
    lockTier: 20,
    coinCost: 22,
    colors: {
      skin: "#e8dccb", skinDark: "#c9b89f", hair: "#1a1210", hat: "#e0a82e",
      hatBand: "#c62828", shirt: "#f3ead2", shirtDark: "#d9cfae", pants: "#1a1a1a",
      shoes: "#2a2018", accent: "#e0a82e",
    },
  },
];

export const LEVELS_META = [
  { index: 0, name: "Managua", short: "1-1", theme: "managua", bg: "bg_managua", bgSegs: ["bg_managua_cathedral", "bg_managua_treeplaza1", "bg_managua_treeplaza2", "bg_managua_0", "bg_managua_stadium", "bg_managua_cathedral2", "bg_managua_2", "bg_managua_trees"], treeParallax: { seg1: "bg_managua_treeplaza1", seg2: "bg_managua_treeplaza2", far1: "bg_managua_treeplaza1_far", far2: "bg_managua_treeplaza2_far", near1: "bg_managua_treeplaza1_near", near2: "bg_managua_treeplaza2_near" }, song: "aguadecoco", sky: ["#5fb7ff", "#bfe6ff"], ground: "#5a5f66", groundTop: "#7b818a", alwaysUnlocked: true },
  { index: 1, name: "Granada Colonial", short: "1-2", theme: "granada", bg: "bg_granada", bgSegs: ["bg_granada_0", "bg_granada_1", "bg_granada_2"], song: "jamaica", sky: ["#7fd0ff", "#ffe9b0"], ground: "#8a5a3a", groundTop: "#b87a4a", hazardSprite: "carriage", alwaysUnlocked: true },
  { index: 2, name: "San Juan del Sur Beach", short: "1-3", theme: "sanjuan", bg: "bg_sanjuan", bgSegs: ["bg_sanjuan_0", "bg_sanjuan_1", "bg_sanjuan_2"], song: "weekend", sky: ["#ff7e5f", "#feb47b"], ground: "#e6c98f", groundTop: "#f3dca8", hazardSprite: "tuktuk", bossLevel: true, alwaysUnlocked: true },
  { index: 3, name: "León", short: "1-4", theme: "cerronegro", bg: "bg_cerronegro", bgSegs: ["bg_cerronegro_3", "bg_cerronegro_0", "bg_cerronegro_1", "bg_cerronegro_2"], song: "nicaragua", sky: ["#3a8fe0", "#bfe6ff"], ground: "#2a2622", groundTop: "#48413a", hazardSprite: "tuktuk", influencedBy: "JavyDade", influencedByUrl: "https://open.spotify.com/artist/5x2MghffUs9Ypcb9pOsrWH?si=nz-vB_sESQmmomJ8ogIEVA", alwaysUnlocked: true },
  { index: 4, name: "Bluefields", short: "1-5", theme: "bluefields", bg: "bg_bluefields", bgSegs: ["bg_bluefields_0", "bg_bluefields_1", "bg_bluefields_2", "bg_bluefields_3"], song: "liquor", sky: ["#3aa0e6", "#cdeffd"], ground: "#9a5a3e", groundTop: "#c47a4e", hazardSprite: "maypole", abuelaSprite: "abuela_carib", influencedBy: "NicaFlow", influencedByUrl: "https://www.tiktok.com/@nicaflow505", alwaysUnlocked: true },
  { index: 5, name: "Corn Island", short: "1-6", theme: "cornisland", bg: "bg_cornisland", cardBg: "bg_cornisland_card", bgSegs: ["bg_cornisland_0", "bg_cornisland_1", "bg_cornisland_2", "bg_cornisland_3", "bg_cornisland_4", "bg_cornisland_5"], bgEndPinned: true, song: "nicaragua", sky: ["#3aa0e6", "#cdeffd"], ground: "#e6d8a8", groundTop: "#f5ecc8", hazardSprite: "moto", abuelaSprite: "abuela_carib", alwaysUnlocked: true },
];

// ---- Featured Special Levels: standalone promo levels grouped by city, shown
// in their own section before the Bonus levels. Not part of the numbered story.
export const FEATURED_LEVELS = [
  {
    index: 20, featured: true, cityId: "sjds", city: "San Juan del Sur", lengthIndex: 0, shareKey: "eltimon",
    name: "El Timón Restaurante", short: "★", theme: "sanjuan",
    bg: "bg_eltimon_2", cardBg: "bg_eltimon_card",
    bgSegs: ["bg_eltimon_2", "bg_eltimon_14", "bg_eltimon_13", "bg_eltimon_12", "bg_eltimon_1", "bg_eltimon_9", "bg_eltimon_5"],
    song: "bebiendo",
    sky: ["#f2a65a", "#ffe0b0"], ground: "#e6c98f", groundTop: "#f3dca8",
    hazardSprite: "tuktuk",
    road: true,
    // Road surface per 960px stretch (cycled). "cobble" near the El Timón start
    // (with a painted crosswalk on the very first stretch), then dirt/asphalt mix.
    roadPattern: ["cobble", "cobble", "dirt", "asphalt", "dirt", "asphalt", "dirt", "asphalt"],
    sponsorName: "El Timón", sponsorFullName: "Restaurante El Timón", sponsorLogo: "eltimon_logo", shareVersion: 2,
    sponsorEmoji: "🍤",
    sponsorLink: "https://eltimonsanjuandelsur.net/",
    coupon: { brand: "El Timón", percent: 10, days: 7 },
    influencedBy: "El Timón · San Juan del Sur",
    influencedByUrl: "https://www.instagram.com/eltimonsanjuandelsur/",
    alwaysUnlocked: true,
  },
  {
    // Pan de Vida — Granada's favorite neighborhood restaurant. Same template as El Timón
    // (Easy featured level + coupon + $25 Extreme gift-card challenge).
    index: 21, featured: true, cityId: "granada", city: "Granada", lengthIndex: 0, shareKey: "pandevida", shareVersion: 2,
    name: "Pan de Vida Granada", short: "★", theme: "granada",
    bg: "bg_pandevida_0", cardBg: "bg_pandevida_card3",
    bgSegs: ["bg_pandevida_0", "bg_pandevida_1", "bg_pandevida_2", "bg_pandevida_3", "bg_pandevida_4", "bg_pandevida_5"],
    song: "fritanga",
    sky: ["#f2a65a", "#ffe0b0"], ground: "#b98a5a", groundTop: "#d4a774",
    hazardSprite: "carriage",
    itemSprite: "bread", itemSprites: ["bread", "pizza", "sushi"], itemSfx: "bite", itemPop: "provecho",
    road: true,
    roadPattern: ["cobble", "cobble", "cobble", "dirt", "cobble", "asphalt", "cobble", "dirt"],
    sponsorName: "Pan de Vida", sponsorFullName: "Pan de Vida Granada", sponsorLogo: "pandevida_logo",
    sponsorTagline: "Granada's Favorite Neighborhood Restaurant!", sponsorTaglineEs: "¡El restaurante favorito del barrio en Granada!",
    sponsorLink: "https://www.facebook.com/pandevidagranada",
    sponsorEmoji: "🥖",
    coupon: { brand: "Pan de Vida", percent: 10, days: 7 },
    influencedBy: "Pan de Vida · Granada",
    influencedByUrl: "https://www.facebook.com/pandevidagranada",
    alwaysUnlocked: true,
  },
];

// Featured levels grouped by city for the LevelSelect "Featured Special Levels" section.
export const FEATURED_CITIES = [
  { id: "sjds", name: "San Juan del Sur", levels: FEATURED_LEVELS.filter((l) => l.cityId === "sjds") },
  { id: "granada", name: "Granada", levels: FEATURED_LEVELS.filter((l) => l.cityId === "granada") },
];

const { GROUND_Y } = GAME;

// Three difficulties. Multipliers scale enemy counts/speed and hazard rates.
// throwMul / policeMul multiply spawn intervals (smaller = more frequent).
export const DIFFICULTIES = {
  facil:   { id: "facil",   lives: 5, speedMul: 0.8,  dogMul: 0.65, throwMul: 1.5, policeMul: 1.5, policeSpeed: 0.85, bossHp: 6,  chargerMod: 0 },
  normal:  { id: "normal",  lives: 3, speedMul: 1.0,  dogMul: 1.0,  throwMul: 1.0, policeMul: 1.0, policeSpeed: 1.0,  bossHp: 8,  chargerMod: 4 },
  extremo: { id: "extremo", lives: 2, speedMul: 1.55, dogMul: 1.6,  throwMul: 0.5, policeMul: 0.5, policeSpeed: 1.6,  bossHp: 14, chargerMod: 2 },
};
export const DIFFICULTY_LIST = [DIFFICULTIES.facil, DIFFICULTIES.normal, DIFFICULTIES.extremo];

// Difficulty progression: each level can be cleared on all 3 tiers. Clearing a
// tier for the first time awards coins (server-authoritative, no farming).
export const TIER_ORDER = ["facil", "normal", "extremo"];
export const TIER_COINS = { facil: 1, normal: 1, extremo: 1 };
export function nextTier(id) {
  const i = TIER_ORDER.indexOf(id);
  return i >= 0 && i < TIER_ORDER.length - 1 ? TIER_ORDER[i + 1] : null;
}

// Characters earned FREE by beating a boss level. afterLevel = the level index a
// player must have cleared to be "one level away" from that reward.
export const BOSS_REWARDS = [
  { charId: "gigantona", levelIndex: 2, afterLevel: 1 },
  { charId: "enanocabezon", levelIndex: 7, afterLevel: 5 },
];
export function hasNearbyUnlock(user) {
  if (!user) return false;
  const owned = user.unlocked_chars || [];
  const done = user.completed_tiers || {};
  return BOSS_REWARDS.some((r) => !owned.includes(r.charId) && (done[String(r.afterLevel)] || []).length > 0);
}

// Story challenges: clear a specific level with a specific character → earn a badge.
export const CHALLENGES = [
  { id: "leon_javydade", charId: "javydade", levelIndex: 3, badge: "🎵", color: "#3a8fe0", nameKey: "challengeLeonName", descKey: "challengeLeonDesc" },
  { id: "bluefields_nicaflow", charId: "nicaflow", levelIndex: 4, badge: "🎶", color: "#3aa0e6", nameKey: "challengeBluefieldsName", descKey: "challengeBluefieldsDesc" },
];

// Deterministic Daily Challenge: same level + difficulty for everyone each day.
// Uses Nicaragua local date (America/Managua, UTC-6) so the challenge rolls over at
// local midnight — not UTC midnight (which would flip a day early at 6pm local).
export function nicaraguaToday() {
  try {
    return new Intl.DateTimeFormat("en-CA", { timeZone: "America/Managua" }).format(new Date());
  } catch {
    return new Date(Date.now() - 6 * 3600 * 1000).toISOString().slice(0, 10);
  }
}
export function getDailyChallenge(dateStr) {
  const d = dateStr || nicaraguaToday();
  let h = 0;
  for (let i = 0; i < d.length; i++) h = (h * 31 + d.charCodeAt(i)) >>> 0;
  const levelIndex = h % LEVELS_META.length;
  const diffId = DIFFICULTY_LIST[Math.floor(h / 7) % DIFFICULTY_LIST.length].id;
  return { date: d, levelIndex, diffId };
}

function overPit(x, pits, margin = 60) {
  return pits.some((p) => x > p.x - margin && x < p.x + p.w + margin);
}

export function buildLevel(meta, diff = DIFFICULTIES.normal) {
  const idx = meta.index;
  // EQUAL DIFFICULTY ACROSS ALL LEVELS: every map shares one baseline so the
  // challenge does NOT escalate by level — only the chosen difficulty
  // (facil / normal / extremo) changes the intensity. Counts scale with the
  // map's length so the *density* (felt difficulty) stays identical on every map.
  const sidx = 0;
  const lenIdx = (meta.lengthIndex != null ? meta.lengthIndex : idx);
  const W = (6000 + lenIdx * 800) * 2; // levels can vary in length; density stays constant
  const platforms = [];
  const enemies = [];
  const items = [];
  const danceSpots = [];

  // ---- Pits (count scales with length) ----
  const pits = [];
  const pitCount = Math.round(W / 1100);
  for (let i = 1; i <= pitCount; i++) {
    pits.push({ x: Math.round(i * (W / (pitCount + 1))), w: 120 + sidx * 14 });
  }
  // Keep a clear landing zone right before the goal so players never fall into a
  // pit at the very end of the map (where the final background image sits).
  const GOAL_X = W - 150;
  for (let k = pits.length - 1; k >= 0; k--) {
    if (pits[k].x + pits[k].w > GOAL_X - 1500) pits.splice(k, 1);
  }

  // ---- Ground segments ----
  let cursor = 0;
  const sorted = [...pits].sort((a, b) => a.x - b.x);
  for (const pit of sorted) {
    if (pit.x > cursor) platforms.push({ x: cursor, y: GROUND_Y, w: pit.x - cursor, h: 240, type: "ground" });
    cursor = pit.x + pit.w;
  }
  platforms.push({ x: cursor, y: GROUND_Y, w: W - cursor, h: 240, type: "ground" });

  // ---- Bridge platforms over pits ----
  for (const pit of pits) {
    platforms.push({ x: pit.x + pit.w / 2 - 70, y: GROUND_Y - 116, w: 140, h: 22, type: "block" });
    items.push({ type: "beer", x: pit.x + pit.w / 2 - 8, y: GROUND_Y - 170, taken: false });
  }

  // ---- Extra floating platforms (count scales with length) ----
  const platCount = Math.floor((W - 650) / 700);
  for (let i = 0; i < platCount; i++) {
    const px = 650 + i * 700;
    if (px > W - 300) break;
    if (overPit(px, pits, 90)) continue;
    const high = i % 2 === 0;
    const py = GROUND_Y - (high ? 120 : 196);
    platforms.push({ x: px, y: py, w: 130, h: 22, type: "block" });
    items.push({ type: "beer", x: px + 55, y: py - 54, taken: false });
    // Abuelas perched on the higher blocks (consistent on every level).
    if (!high) {
      enemies.push({ type: "abuela", x: px + 45, y: py - 52, baseX: px + 45, range: 0, dir: -1, throwT: 30 + i * 8, rapid: diff.id === "extremo" && i % 2 === 1, alive: true });
    }
  }

  // ---- Ground dogs (count scales with map length; speed/chargers set by difficulty only) ----
  const dogCount = Math.max(6, Math.round((W / 920) * diff.dogMul));
  for (let i = 0; i < dogCount; i++) {
    let x = 520 + i * Math.round((W - 900) / dogCount);
    if (overPit(x, pits)) x += 200;
    const isExtremoCharger = diff.id === "extremo" && diff.chargerMod > 0 && i % diff.chargerMod === 0;
    // Normal always has exactly 2 charging dogs on every level.
    const isNormalCharger = diff.id === "normal" && (i === Math.floor(dogCount / 3) || i === Math.floor((dogCount * 2) / 3));
    const charger = isExtremoCharger || isNormalCharger;
    enemies.push({
      type: "dog", x, y: GROUND_Y - 34, baseX: x,
      range: 90 + (i % 3) * 30, dir: i % 2 === 0 ? 1 : -1,
      speed: (charger ? 1.0 : 1.3) * diff.speedMul, charger, charging: false, alive: true,
    });
  }

  // ---- Ground abuelas (spaced across the level; rapid scales with difficulty) ----
  const abCount = Math.floor(W / (1500 - sidx * 80));
  const abSpacing = Math.max(900, Math.floor((W - 2600) / Math.max(1, abCount)));
  for (let i = 0; i < abCount; i++) {
    let x = 1500 + i * abSpacing;
    if (x > W - 600) break;
    if (overPit(x, pits)) x += 200;
    const rapid = diff.id === "extremo" && i % 2 === 0;
    enemies.push({ type: "abuela", x, y: GROUND_Y - 52, baseX: x, range: 0, dir: -1, throwT: 50 + i * 16, rapid, alive: true });
  }

  // ---- Dance spots (spaced across the level) ----
  const danceCount = Math.floor(W / 1400);
  for (let i = 0; i < danceCount; i++) {
    let x = 820 + i * 1400;
    if (x > W - 400) break;
    if (overPit(x, pits)) x += 180;
    danceSpots.push({ x, y: GROUND_Y, used: false });
  }

  // ---- Beer arc (count scales with length) ----
  const beerCount = Math.floor((W - 800) / 460);
  for (let i = 0; i < beerCount; i++) {
    const bx = 400 + i * 460;
    if (bx > W - 400 || overPit(bx, pits)) continue;
    items.push({ type: "beer", x: bx, y: GROUND_Y - 60 - (i % 3) * 30, taken: false });
  }

  // ---- Boss on the final level ----
  let boss = null;
  if (idx === 2) {
    const bx = W - 360;
    boss = {
      x: bx, y: GROUND_Y - 120, w: 120, h: 120, baseY: GROUND_Y - 120,
      hp: diff.bossHp, maxHp: diff.bossHp, alive: true, active: false, enraged: false, dir: -1, vy: 0,
      throwT: 70, hurtT: 0, jumpT: 120, triggerX: bx - 520,
    };
  }

  // ---- Daily treasure chest: near the start on solid ground so every player finds it daily ----
  let chestX = 760;
  if (overPit(chestX, pits, 130)) chestX = 1040;
  const chest = { x: chestX, y: GROUND_Y - 46 };

  return {
    ...meta, width: W, goalX: W - 150, pits, platforms, enemies, items, danceSpots,
    boss, spawn: { x: 90, y: GROUND_Y - 60 }, diff, chest,
  };
}
